import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import App from '@/App.vue'
import PageQR from '@/pages/PageQR.vue'

Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
  { path: '/', name: 'App' },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
        return savedPosition;
      } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
